import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=93f2a644&scoped=true"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=93f2a644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_1ea54a5d08821f18e5f7625cad052d96/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f2a644",
  null
  
)

export default component.exports